<!-- Tooltip mode: wrap projected content with the htmlTooltip directive -->
<div
  *ngIf="!inline"
  class="driver-card-tooltip-wrapper"
  [htmlTooltip]="tooltipHtml"
  [tooltipPosition]="tooltipPosition"
>
  <ng-content></ng-content>
</div>

<!-- Inline mode: render the card directly -->
<div *ngIf="inline" class="driver-card-inline">
  <div class="dc-header">
    <img
      class="dc-avatar"
      [src]="pictureUrl"
      [alt]="displayName"
      onerror="this.src = 'assets/img/tractordriver.jpg'"
    />
    <div class="dc-main-info">
      <div class="dc-name-row">
        <span class="dc-name">{{ displayName }}</span>
        <span *ngIf="driver.driverNo" class="dc-driver-no">{{ driver.driverNo }}</span>
      </div>
      <div *ngIf="driver.boardName" class="dc-board">{{ driver.boardName }}</div>
      <div *ngIf="driver.billToClientName" class="dc-billto">{{ driver.billToClientName }}</div>
    </div>
    <button
      class="dc-copy-btn"
      [class.dc-copy-btn--copied]="copied"
      type="button"
      (click)="copyToClipboard()"
      [title]="copied ? 'Copied!' : 'Copy to clipboard'"
    >
      <i [class]="copied ? 'pi pi-check' : 'pi pi-copy'"></i>
    </button>
  </div>

  <div
    class="dc-contact-row"
    *ngIf="driver.currentLocation || driver.cellphone || driver.homeLocation"
  >
    <div *ngIf="driver.currentLocation" class="dc-contact-item">
      <i class="fa fa-map-marker"></i>
      <span>{{ shortenLocation(driver.currentLocation) }}</span>
    </div>
    <div *ngIf="driver.cellphone" class="dc-contact-item">
      <i class="fa fa-phone"></i>
      <span>{{ formatPhone(driver.cellphone) }}</span>
    </div>
    <div *ngIf="driver.homeLocation" class="dc-contact-item">
      <i class="fa fa-home"></i>
      <span>{{ shortenLocation(driver.homeLocation) }}</span>
    </div>
  </div>

  <div
    class="dc-equipment-row"
    *ngIf="
      driver.tractorNumber ||
      driver.trailerNumber ||
      driver.autoTransmissionOnly ||
      driver.teamMembers?.length
    "
  >
    <span *ngIf="driver.tractorNumber" class="dc-badge dc-badge-tractor">
      <i class="fa fa-truck"></i> {{ driver.tractorNumber }}
    </span>
    <span *ngIf="driver.trailerNumber" class="dc-badge dc-badge-trailer">
      <i class="fa fa-subway"></i> {{ driver.trailerNumber }}
    </span>
    <span *ngIf="driver.autoTransmissionOnly" class="dc-badge dc-badge-auto">AUTO</span>
    <span *ngIf="driver.teamMembers?.length" class="dc-badge dc-badge-team">
      <i class="fa fa-users"></i> {{ driver.teamMembers!.join(", ") }}
    </span>
  </div>

  <div *ngIf="driver.specialNote" class="dc-note">
    <i class="fa fa-info-circle"></i>
    <span>{{ driver.specialNote }}</span>
  </div>
</div>
